import React from 'react';
import { marketingUrl } from 'helpers/constants';
import styles from './Footer.module.scss';

const getYear = () => new Date().getFullYear();

export const Footer = () => (
  <footer className={styles.specialFooter}>
    <div className={styles.specialCopyright}>Copyright &copy; {getYear()} Nira</div>

    <nav className={styles.specialFooterNav}>
      <a className={styles.specialNavItem} href={`${marketingUrl}`}>
        Home
      </a>
      <a className={styles.specialNavItem} href={`${marketingUrl}terms`}>
        Terms of Service
      </a>
      <a className={styles.specialNavItem} href={`${marketingUrl}privacy`}>
        Privacy Policy
      </a>
    </nav>
  </footer>
);
